/* eslint-disable */
import axios from "axios";
import store from "@/store";
import moment from "moment";
import customModal from "../customModal/customModal.vue";
export default {
    name: "RunKriModal",
    components: {
        customModal,
    },

    //   props: {
    //     studyId: {
    //       type: String,
    //       required: true
    //     }
    //   },

    data() {
        return {
            form: {
                riskName: "",
                version: "1",
                dataScope: "",
                dataScopeId: "",
                fromDate: "",
                toDate: "",
                siteId: "",
                siteCode: "",
                operator: 0,
                compareValue: "Y",

            },
            studyId: "",
            token: "",
            baseurl: process.env.VUE_APP_Service_URL,
            thresholdList: [],
            sites: [],
            selectedSite: "",
            errors: {
                riskName: "",
                dataScope: "",
                site: "",
                fromDate: "",
                toDate: ""
                },
        };
    },
    mounted() {
        window.addEventListener("studyIdChanged", () => {
            this.studyId = store.getters.getStudyIs;
            this.token = store.getters.getIdToken;
            this.getsites();
            this.getThresholdList();
        });

        this.studyId = store.getters.getStudyIs;
        this.token = store.getters.getIdToken;
        this.getsites();
        this.getThresholdList();
    },

    methods: {
        async runKri() {
            if (!this.validateForm()) {
                return;
            }
            try {

                if (this.form.dataScope === "Study") {
                    this.form.dataScopeId = this.studyId;
                    this.form.siteId = "";
                    this.form.siteCode = "";
                }
                else if (this.form.dataScope === "Site" && this.selectedSite) {
                    this.form.dataScopeId = this.selectedSite.siteID;
                    this.form.siteId = this.selectedSite.siteID;
                    this.form.siteCode = this.selectedSite.siteCode;
                }

                let params = {
                    ...this.form,
                    studyId: this.studyId
                };

                const res = await axios.post(
                    `${this.baseurl}/forms/rbqm/generickpi`,
                    params,
                    {
                        headers: {
                            Authorization: `Bearer ${this.token}`,
                        },
                    }
                );

                alert("KRI run successfully");
                this.$emit("closeModal");
                this.$emit("run-kri-success");

            } catch (err) {
                this.$emit("run-kri-error", err);
            }
        },

        async getThresholdList() {

            try {
                const res = await axios.get(
                    `${this.baseurl}/forms/rbqm/getthreshold`,
                    {
                        params: {
                            studyId: this.studyId,
                            isActive: true,

                            pageindex: this.currentPage,
                            pagesize: this.pageSize,
                        },
                        headers: {
                            Authorization: `Bearer ${this.token}`,
                        },
                    }
                );

                this.thresholdList = res.data.entities || [];

            } catch (err) {
                console.error("Error fetching thresholds", err);
                this.thresholdList = [];
            } finally {
            }
        },
        async getsites() {
            await axios
                .get(`${this.baseurl}/management/site/getallsitesbyuser?studyId=${this.studyId}&getAll=false`, {
                    headers: {
                        Authorization: "Bearer " + this.token,
                        "Content-Type": "application/json",
                    },
                })
                .then((res) => {
                    this.sites = res.data;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        validateForm() {
            this.errors = {
                riskName: "",
                dataScope: "",
                site: "",
                fromDate: "",
                toDate: ""
            };

            let isValid = true;

            if (!this.form.riskName) {
                this.errors.riskName = "Risk Indicator is required";
                isValid = false;
            }

            if (!this.form.dataScope) {
                this.errors.dataScope = "Data Scope is required";
                isValid = false;
            }

            if (this.form.dataScope === "Site" && !this.selectedSite) {
                this.errors.site = "Site Code is required";
                isValid = false;
            }
            if (!this.form.fromDate) {
                this.errors.fromDate = "From Date is required";
                isValid = false;
            }
            if (!this.form.toDate) {
                this.errors.toDate = "To Date is required";
                isValid = false;
            }

            return isValid;
        },
        clearError(field) {
            if (this.errors[field]) {
                this.errors[field] = "";
            }
        }


    }
};